export const portfolioFilteringOptions = [
  {
    value: 'gainLoss' as const,
    label: {
      en: 'All-Time Return',
      de: 'Allzeithoch-Gewinn',
    },
  },
  {
    value: 'holdings' as const,
    label: {
      en: 'Holdings',
      de: 'Bestand',
    },
  },
  {
    value: 'breakdownPercentage' as const,
    label: {
      en: 'Weighting',
      de: 'Gewichtung',
    },
  },
];

export type PortfolioFilteringOptions =
  (typeof portfolioFilteringOptions)[number]['value'];
